import './css_logo.css';

import { Box, Image, Progress, Text, VStack } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { getClientConsentInfoByToken } from '../../services/previdencia-individual/consentimento.service';
import SVGLogo from './logo_sulamerica.svg';
import { QuizLGPD } from './QuizLGPD';
import { Term } from './Term';

export const ConsentimentoHome = (): JSX.Element => {
  const [apiReturned, setReturned] = useState(false);
  const [isError, setError] = useState<{ error: boolean; message?: string }>({
    error: false,
    message: 'Não foi possível completar a requisição.'
  });
  const [quiz, setQuiz] = useState(false);
  const [searchParams] = useSearchParams();
  const { token: pathToken } = useParams();
  const navigate = useNavigate();

  const bffUrl = process.env.REACT_APP_API_URL;
  const url = `${bffUrl}/consentimentos/term`;
  //const searchParams = window.location.search;
  const token = pathToken ?? searchParams.get('token');
  sessionStorage.setItem('token', String(token));

  const { isLoading } = useQuery(
    ['query-load-consent-info'],
    () => getClientConsentInfoByToken(String(token)),
    {
      enabled: !!token,
      retryDelay: 3000,
      refetchOnWindowFocus: false,
      onSuccess: (data: any) => {
        if (data?.status === 400) {
          setError({
            error: true,
            message: data?.message
          });
          return;
        }
        console.log(data);
        if (data) {
          sessionStorage.setItem('consentimento', JSON.stringify(data));
          if (data.questions_info.needAnswerQuestions)
            return navigate('/consentimento/quiz');
        }

        navigate('/consentimento/accept-term');
      },
      onError: (err) => {
        setError({
          error: true
        });
        return;
      }
    }
  );

  /* useEffect(() => {
    //get from API
    selectPage();
  }, []); */

  const selectPage = async () => {
    /* const headers = {
      token: token
    };

    const data = {};
    axios({
      method: 'POST',
      url: `${url}`,
      data: data,
      headers
    })
      .then((response) => {
        if (response.data) {
          setReturned(true);
          setQuiz(true);
        }
      })
      .catch((error) => {
        setReturned(false);
      }); */
  };

  // TODO: Passar uma função que atualiza o state quiz para o LGDP, removendo o TERM das rotas

  //return <>{apiReturned && (quiz ? <QuizLGPD /> : <Term />)}</>;
  if (isError.error)
    return (
      <Box
        position={'absolute'}
        top={0}
        left={0}
        w="100vw"
        h={'100vh'}
        display="flex"
        bg={'white'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <VStack>
          <Image
            src={SVGLogo}
            width={256}
            height={256}
            className="svg-elem-1"
          />
          <Text>{isError.message}</Text>
        </VStack>
      </Box>
    );
  return (
    <Box
      position={'absolute'}
      top={0}
      left={0}
      w="100vw"
      h={'100vh'}
      display="flex"
      bg={'white'}
      justifyContent={'center'}
      alignItems={'center'}
    >
      <Box>
        <Image src={SVGLogo} width={256} height={256} className="svg-elem-1" />
        <Progress size="xs" isIndeterminate />
      </Box>
    </Box>
  );
};
